document.documentElement.classList.replace("no-js", "js");

init();

function init() {
    initNavigation();
}

// =====================
// Navigation (Hamburger Burger)
// =====================
function initNavigation() {
    const root = document.documentElement;
    root.classList.add("js");

    const toggleButton = document.querySelector(".menu-toggle");
    const nav = document.getElementById("main-nav");

    if (!toggleButton || !nav) return;

    const firstLink = nav.querySelector("a");

    function openMenu() {
        nav.classList.add("is-open");
        toggleButton.setAttribute("aria-expanded", "true");
        toggleButton.setAttribute("aria-label", "Hauptnavigation schliessen");
        firstLink?.focus();
    }

    function closeMenu({ returnFocus = true } = {}) {
        nav.classList.remove("is-open");
        toggleButton.setAttribute("aria-expanded", "false");
        toggleButton.setAttribute("aria-label", "Hauptnavigation öffnen");

        if (returnFocus) {
            toggleButton.focus();
        }
    }

    toggleButton.addEventListener("click", () => {
        const isOpen = toggleButton.getAttribute("aria-expanded") === "true";
        isOpen ? closeMenu() : openMenu();
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            const isOpen = toggleButton.getAttribute("aria-expanded") === "true";
            if (isOpen) closeMenu();
        }
    });
}

// Service Worker Registrierung für PWA (Progressive Web App)
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        import("virtual:pwa-register").then(({ registerSW }) => {
            registerSW({ immediate: false });
        });
    });
}
